import globalAxios from "../GlobalAxios";

const loginApi = async (name, password) => {
    // const credentials = btoa(`${name}:${password}`);
    const credentials = btoa(
        encodeURIComponent(`${name}:${password}`).replace(
          /%([0-9A-F]{2})/g,
          (_, p1) => String.fromCharCode(parseInt(p1, 16))
        )
      );
    const result = await globalAxios.post("/api/auth/login", {}, {
        headers: {
            'Authorization': `Basic ${credentials}`
        },
        withCredentials: true
    });
    return result.data;
};

const logoutApi = async () => {
    try {
        const params = {
            session_token: localStorage.getItem('info')
        }
        await globalAxios.post('/api/auth/logout', params);
        sessionStorage.removeItem('UserAccessToken');
    } catch (error) {
        console.error('error', error);
    }
};

const qnaApi = async (qnaData) => {
    try {
        const res = await globalAxios.post('/api/service/qna', qnaData);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const programListApi = async () => {
    try {
        const res = await globalAxios.get('/api/service/info');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const usercheck = async () => {
    try {
        const res = await globalAxios.get('/api/auth/usercheck');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

// const checkStatus = async (status) => {
//     try {
//         await globalAxios.get('/api/service/checkVal', {params: {status}});
//         // return res.data;
//     } catch (error) {
//         console.error("error", error);
//     }
// }

const qnaSessionListApi = async () => {
    try {
        const res = await globalAxios.get('/api/service/info-session');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

export default {
    loginApi,
    logoutApi,
    qnaApi,
    programListApi,
    usercheck,
    // checkStatus,
    qnaSessionListApi
};